var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandSquaredMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 4.07361C22.5 2.6532 21.3468 1.5 19.9264 1.5H4.07361C2.6532 1.5 1.5 2.6532 1.5 4.07361V19.9264C1.5 21.3468 2.6532 22.5 4.07361 22.5H19.9264C21.3468 22.5 22.5 21.3468 22.5 19.9264V4.07361ZM13.1298 12.0001C13.1298 14.766 10.9028 17.0082 8.15581 17.0082C5.40883 17.0082 3.18164 14.766 3.18164 12.0001C3.18164 9.23415 5.40862 6.99179 8.15581 6.99179C10.903 6.99179 13.1298 9.23415 13.1298 12.0001ZM18.5865 12.0001C18.5865 14.6036 17.473 16.715 16.0994 16.715C14.7258 16.715 13.6123 14.6036 13.6123 12.0001C13.6123 9.39657 14.7256 7.28517 16.0992 7.28517C17.4728 7.28517 18.5863 9.39588 18.5863 12.0001H18.5865ZM20.8184 12.0001C20.8184 14.3322 20.4268 16.2239 19.9437 16.2239C19.4605 16.2239 19.0691 14.3327 19.0691 12.0001C19.0691 9.66744 19.4607 7.77625 19.9437 7.77625C20.4266 7.77625 20.8184 9.66728 20.8184 12.0001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSquaredMedium);
export default __webpack_public_path__ + "static/media/brand_squared_medium.7c8a84cca5dac4046580d958adc97003.svg";
export { ForwardRef as ReactComponent };